export default __webpack_public_path__ + "static/media/bar_chart_arrow_green.d559d64b.svg";